class Archive {
    constructor() {
    }

    static fromRaw(raw) {
        let archive = new Archive();
        archive.raw = raw;
        archive.uuid = raw.uuid;
        archive.name = raw.name;
        archive.description = raw.description;
        archive.archiveSpecifics = raw.archiveSpecifics ? raw.archiveSpecifics.map(ab => ArchiveSpecifics.fromRaw(ab)) : [];

        return archive;
    }

    toRaw() {
        return { name: this.name, description: this.description, archiveSpecifics: this.archiveSpecifics.map(ars => this.toSpecificRow(ars)) };
    }

    toSpecificRow(ars) {
        return {
            hourOfDay: ars.hourOfDay,
            minuteOfHour: ars.minuteOfHour,
            target: ars.target,
            dayOfWeek: ars.dayOfWeek,
            dayOfMonth: ars.dayOfMonth,
            monthOfYear: ars.monthOfYear,
            archiveType: ars.archiveType,
            retention: ars.retention,
            timezone: ars.timezone,
            accessTier: ars.accessTier
        };
    }
}

class ArchiveSpecifics {
    constructor() {
    }

    static fromRaw(raw) {
        let archiveS = new ArchiveSpecifics();
        archiveS.raw = raw;
        archiveS.hourOfDay = raw.hourOfDay;
        archiveS.minuteOfHour = raw.minuteOfHour;
        archiveS.target = raw.target;
        archiveS.dayOfWeek = raw.dayOfWeek;
        archiveS.dayOfMonth = raw.dayOfMonth;
        archiveS.monthOfYear = raw.monthOfYear;
        archiveS.archiveType = raw.archiveType;
        archiveS.retention = raw.retention;
        archiveS.timezone = raw.timezone;
        archiveS.accessTier = raw.accessTier;

        return archiveS;
    }

    toRaw() {
        return {
            hourOfDay: this.hourOfDay,
            minuteOfHour: this.minuteOfHour,
            target: this.target,
            dayOfWeek: this.dayOfWeek,
            dayOfMonth: this.dayOfMonth,
            monthOfYear: this.monthOfYear,
            archiveType: this.archiveType,
            retention: this.retention,
            timezone: this.timezone,
            accessTier: this.accessTier
        };
    }
}

module.exports = Archive;


// WEBPACK FOOTER //
// ./src/azurebackup/model/Archive.js